//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import standardData from "../assets/standard.json";
import latinData from "../assets/Latin/latin-list.json";
import smoothData from "../assets/smooth.json";
import rhythmData from "../assets/rhythm.json";
import tempiData from "../assets/tempi.json";
import { analytics } from "/src/main.js";
import { db } from "../main.js";

export default {
  data() {
    return {
      style: this.$route.params.style.toLowerCase(),
      figures: {
        standard: standardData,
        latin: latinData,
        rhythm: rhythmData,
        smooth: smoothData,
      },
      tempi: tempiData,
      levels: ["newcomer", "bronze", "silver", "gold"],
    };
  },
  computed: {
    dance() {
      return this.$route.params.danceid.toLowerCase().replace(/\s/g, "");
    },
  },
  mounted() {
    var route = this.$route.path;
    analytics.logEvent("screen_view", {
      firebase_screen: `${route}`,
      firebase_screen_class: "screenClass",
    });
  },
};
